<template>
  <div>
    <div class="ban-p">
      <img v-if="result" :src="imageUrl + result.headerImg" />
    </div>
    <div class="g-snva1">
      <div class="wp">
        <subnav :type="6"></subnav>
      </div>
    </div>
    <div class="row-lx1">
      <div class="wp">
        <div class="m-contactb1 fix">
          <div class="l">
            <div class="tit">{{ $t("contactUs.info.tit") }}</div>
            <div class="desc" v-if="result">
              <p class="p p1" v-if="result.contactAddr">
                {{ $t("contactUs.info.adr") }}: {{ result.contactAddr }}
              </p>
              <p class="p p2" v-if="result.contactPost">
                {{ $t("contactUs.info.pos") }}: {{ result.contactPost }}
              </p>
              <p class="p p3" v-if="result.contactTel">
                {{ $t("contactUs.info.tel") }}: {{ result.contactTel }}
              </p>
              <p class="p p4" v-if="result.contactFax">
                {{ $t("contactUs.info.fax") }}: {{ result.contactFax }}
              </p>
              <p class="p p5" v-if="result.contactMail">
                {{ $t("contactUs.info.email") }}: {{ result.contactMail }}
              </p>
            </div>
          </div>
          <div class="r">
            <div class="conMapBg">
              <div class="conMap">
                <img class="bg" src="http://www.bescn.com/images/conMap.png" />
                <ul class="mapList list-unstyled">
                  <li
                    class="mapItem mapItem8"
                    v-if="result && result.branchName2"
                  >
                    <div class="mapDot"></div>
                    <div class="mapConBg">
                      <div class="mapCon">
                        <h3 class="mapTit">
                          {{ result.branchName2 }}
                        </h3>
                        <p v-if="result && result.branchAddr2">
                          {{ result.branchAddr2 }}
                        </p>
                        <p v-if="result && result.branchTel2">
                          {{ result.branchTel2 }}
                        </p>
                      </div>
                    </div>
                  </li>
                  <li
                    class="mapItem mapItem6"
                    v-if="result && result.branchName3"
                  >
                    <div class="mapDot"></div>
                    <div class="mapConBg">
                      <div class="mapCon">
                        <h3 class="mapTit">
                          {{ result.branchName3 }}
                        </h3>
                        <p v-if="result && result.branchAddr3">
                          {{ result.branchAddr3 }}
                        </p>
                        <p v-if="result && result.branchTel3">
                          {{ result.branchTel3 }}
                        </p>
                      </div>
                    </div>
                  </li>

                  <li
                    class="mapItem mapItem1"
                    v-if="result && result.branchName6"
                  >
                    <div class="mapDot"></div>
                    <div class="mapConBg">
                      <div class="mapCon">
                        <h3 class="mapTit">
                          {{ result.branchName6 }}
                        </h3>
                        <p v-if="result && result.branchAddr6">
                          {{ result.branchAddr6 }}
                        </p>
                        <p v-if="result && result.branchTel6">
                          {{ result.branchTel6 }}
                        </p>
                      </div>
                    </div>
                  </li>

                  <li
                    class="mapItem mapItem4"
                    v-if="result && result.branchName4"
                  >
                    <div class="mapDot"></div>
                    <div class="mapConBg">
                      <div class="mapCon">
                        <h3 class="mapTit">
                          {{ result.branchName4 }}
                        </h3>
                        <p v-if="result && result.branchAddr4">
                          {{ result.branchAddr4 }}
                        </p>
                        <p v-if="result && result.branchTel4">
                          {{ result.branchTel4 }}
                        </p>
                      </div>
                    </div>
                  </li>

                  <li
                    class="mapItem mapItem3"
                    v-if="result && result.branchName1"
                  >
                    <div class="mapDot"></div>
                    <div class="mapConBg">
                      <div class="mapCon">
                        <h3 class="mapTit">
                          {{ result.branchName1 }}
                        </h3>
                        <p v-if="result && result.branchAddr1">
                          {{ result.branchAddr1 }}
                        </p>
                        <p v-if="result && result.branchTel1">
                          {{ result.branchTel1 }}
                        </p>
                      </div>
                    </div>
                  </li>

                  <li
                    class="mapItem mapItem5"
                    v-if="result && result.branchName5"
                  >
                    <div class="mapDot"></div>
                    <div class="mapConBg">
                      <div class="mapCon">
                        <h3 class="mapTit">
                          {{ result.branchName5 }}
                        </h3>
                        <p v-if="result && result.branchAddr5">
                          {{ result.branchAddr5 }}
                        </p>
                        <p v-if="result && result.branchTel5">
                          {{ result.branchTel5 }}
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row-lx2">
      <div class="wp">
        <div class="g-titb1">
          <h3>{{ $t("contactUs.title") }}</h3>
        </div>
        <ul class="ul-adrsb1">
          <li v-if="result && result.branchName1">
            <div class="con">
              <h3>{{ result.branchName1 }}</h3>
              <div class="txt">
                <p>
                  <span
                    v-if="result && result.branchAddr1"
                    >{{ result.branchAddr1 }}</span
                  >
                </p>
                <p>
                  <span
                    v-if="result && result.branchTel1"
                    >{{ result.branchTel1 }}</span
                  >
                </p>
                <p>
                  <span
                    v-if="result && result.branchMail1"
                    >{{ result.branchMail1 }}<br
                  /></span>
                </p>
              </div>
              <a
                :href="`http://api.map.baidu.com/marker?location=${loc1[1]},${loc1[0]}&title=我的位置&content=${result.branchAddr11}&output=html&src=webapp.baidu.openAPIdemo `"
                target="_blank"
                ><div class="seeMap">{{ $t("contactUs.seemap") }}</div></a
              >
            </div>
          </li>
          <li v-if="result && result.branchName2">
            <div class="con">
              <h3>{{ result.branchName2 }}</h3>
              <div class="txt">
                <p>
                  <span
                    v-if="result && result.branchAddr2"
                    >{{ result.branchAddr2 }}</span
                  >
                </p>
                <p>
                  <span
                    v-if="result && result.branchTel2"
                    >{{ result.branchTel2 }}</span
                  >
                </p>
                <p>
                  <span
                    v-if="result && result.branchMail2"
                    >{{ result.branchMail2 }}<br
                  /></span>
                </p>
              </div>
              <a
                :href="`http://api.map.baidu.com/marker?location=${loc2[1]},${loc2[0]}&title=我的位置&content=${result.branchAddr21}&output=html&src=webapp.baidu.openAPIdemo `"
                target="_blank"
                ><div class="seeMap">{{ $t("contactUs.seemap") }}</div></a
              >
            </div>
          </li>
          <li v-if="result && result.branchName3">
            <div class="con">
              <h3>{{ result.branchName3 }}</h3>
              <div class="txt">
                <p>
                  <span
                    v-if="result && result.branchAddr3"
                    >{{ result.branchAddr3 }}</span
                  >
                </p>
                <p>
                  <span
                    v-if="result && result.branchTel3"
                    >{{ result.branchTel3 }}</span
                  >
                </p>
                <p>
                  <span
                    v-if="result && result.branchMail3"
                    >{{ result.branchMail3 }}<br
                  /></span>
                </p>
              </div>
              <a
                :href="`http://api.map.baidu.com/marker?location=${loc3[1]},${loc3[0]}&title=我的位置&content=${result.branchAddr31}&output=html&src=webapp.baidu.openAPIdemo `"
                target="_blank"
                ><div class="seeMap">{{ $t("contactUs.seemap") }}</div></a
              >
            </div>
          </li>
          <li v-if="result && result.branchName4">
            <div class="con">
              <h3>{{ result.branchName4 }}</h3>
              <div class="txt">
                <p>
                  <span
                    v-if="result && result.branchAddr4"
                    >{{ result.branchAddr4 }}</span
                  >
                </p>
                <p>
                  <span
                    v-if="result && result.branchTel4"
                    >{{ result.branchTel4 }}</span
                  >
                </p>
                <p>
                  <span
                    v-if="result && result.branchMail4"
                    >{{ result.branchMail4 }}<br
                  /></span>
                </p>
              </div>
              <a
                :href="`http://api.map.baidu.com/marker?location=${loc4[1]},${loc4[0]}&title=我的位置&content=${result.branchAddr41}&output=html&src=webapp.baidu.openAPIdemo `"
                target="_blank"
                ><div class="seeMap">{{ $t("contactUs.seemap") }}</div></a
              >
            </div>
          </li>
          <li v-if="result && result.branchName5">
            <div class="con">
              <h3>{{ result.branchName5 }}</h3>
              <div class="txt">
                <p>
                  <span
                    v-if="result && result.branchAddr5"
                    >{{ result.branchAddr5 }}</span
                  >
                </p>
                <p>
                  <span
                    v-if="result && result.branchTel5"
                    >{{ result.branchTel5 }}</span
                  >
                </p>
                <p>
                  <span
                    v-if="result && result.branchMail5"
                    >{{ result.branchMail5 }}<br
                  /></span>
                </p>
              </div>
              <a
                :href="`http://api.map.baidu.com/marker?location=${loc5[1]},${loc5[0]}&title=我的位置&content=${result.branchAddr51}&output=html&src=webapp.baidu.openAPIdemo `"
                target="_blank"
                ><div class="seeMap">{{ $t("contactUs.seemap") }}</div></a
              >
            </div>
          </li>
          <li v-if="result && result.branchName6">
            <div class="con">
              <h3>{{ result.branchName6 }}</h3>
              <div class="txt">
                <p>
                  <span
                    v-if="result && result.branchAddr6"
                    >{{ result.branchAddr6 }}</span
                  >
                </p>
                <p>
                  <span
                    v-if="result && result.branchTel6"
                    >{{ result.branchTel6 }}</span
                  >
                </p>
                <p>
                  <span
                    v-if="result && result.branchMail6"
                    >{{ result.branchMail6 }}<br
                  /></span>
                </p>
              </div>
              <a
                :href="`http://api.map.baidu.com/marker?location=${loc6[1]},${loc6[0]}&title=我的位置&content=${result.branchAddr61}&output=html&src=webapp.baidu.openAPIdemo `"
                target="_blank"
                ><div class="seeMap">{{ $t("contactUs.seemap") }}</div></a
              >
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { Loading } from 'element-ui';
import subnav from '@/components/subnav';
export default {
  components: {
    subnav
  },
  data () {
    return {
      loading: true,
      result: null,
      // 6个地址
      loc1: [],
      loc2: [],
      loc3: [],
      loc4: [],
      loc5: [],
      loc6: [],
      pageInfo: {
        zhId: '1436544285003956226',
        enId: '1436544247485906945'
      }
    }
  },
  created () {
    /* let lang = localStorage.getItem("locale") || 'zh';
    this.lang = lang;
    this.$i18n.locale = lang; */
    Loading.service();
    let that = this;
    /* if (that.$i18n.locale === 'zh') {
      that.getContact(that.pageInfo.zhId);
    } else if (that.$i18n.locale === 'en') {
      that.getContact(that.pageInfo.enId);
    } */

    that.getContact(that.pageInfo.enId);
  },
 /*  watch: {
    '$i18n.locale' (newValue) {
      Loading.service();
      if (this.$i18n.locale === 'zh') {
        this.getContact(this.pageInfo.zhId);
      } else if (this.$i18n.locale === 'en') {
        this.getContact(this.pageInfo.enId);
      }
    }
  }, */
  methods: {
    changeMapContents(content){
        content=content.replaceAll(" ","%09")
        return content;
    },
    // 获取联系我们信息
    getContact (id) {
      let that = this;
      let data = {
        id: id
      };
      that.$http
        .getContact(data)
        .then((res) => {
          if (res.code == 200) {
            Loading.service().close();
            let result = res.result;
            that.result = result;
            that.loc1 = result.loc1?result.loc1.split(','):[];
            that.loc2 = result.loc2?result.loc2.split(','):[];
            that.loc3 = result.loc3?result.loc3.split(','):[];
            that.loc4 = result.loc4?result.loc4.split(','):[];
            that.loc5 = result.loc5?result.loc5.split(','):[];
            that.loc6 = result.loc6?result.loc6.split(','):[];

            that.result.branchAddr11=this.changeMapContents(result.branchAddr5)
            that.result.branchAddr21=this.changeMapContents(result.branchAddr6)
             that.result.branchAddr31=this.changeMapContents(result.branchAddr5)
            that.result.branchAddr41=this.changeMapContents(result.branchAddr6)
            that.result.branchAddr51=this.changeMapContents(result.branchAddr5)
            that.result.branchAddr61=this.changeMapContents(result.branchAddr6)

          } else {
            Loading.service().close();
          }
        })
        .catch((err) => { 
          that.$message(
              {
                message:err,
                type: 'error'
              }
            );
        });
    },
  },
}
</script>

<style>
</style>